export var actionTypePrefix = '@@USERS';
export var friendsStreamId = '@@USERS_FRIENDS';
//# sourceMappingURL=constants.js.map